import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Container } from 'reactstrap';
import { TabsHash } from '../../../components/TabsHash';
import { TranslationsKeys } from '../../../locales/translations';
import { StudentsRemovalRequestsPending } from './StudentsRemovalRequestsPending/StudentsRemovalRequestsPending';
import { StudentsRemovalRequestsResolved } from './StudentsRemovalRequestsResolved/StudentsRemovalRequestsResolved';

export function StudentsRemovalRequestsManage() {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT,
  );

  const tabs = useMemo(
    () => [
      {
        key: 'requests-pending',
        name: t(`tabs.requests-pending`),
        content: (
          <div className="my-3">
            <StudentsRemovalRequestsPending />
          </div>
        ),
      },
      {
        key: 'requests-resolved',
        name: t(`tabs.requests-resolved`),
        content: (
          <div className="my-3">
            <StudentsRemovalRequestsResolved />
          </div>
        ),
      },
    ],
    [t],
  );

  return (
    <Container fluid>
      <Card className="px-3">
        <TabsHash tabs={tabs} defaultTab="requests-pending" />
      </Card>
    </Container>
  );
}
